import { useNavigate } from "react-router-dom";
import BackButton from "../../common/components/BackButton";
import useComponents from "../../common/hooks/pages/useComponents";
import useMaintenance from "../../common/hooks/pages/useMaintenance";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import moment from "moment";
import Select from "react-select";
import { usePopup } from "../../common/contexts/PopupContext";

function MaintainanceForm() {
  const navigate = useNavigate();
  const { createMaintenance } = useMaintenance();
  const { getComponents } = useComponents();

  const [components, setComponents] = useState([]);
  const [componentstatus, setComponentstatus] = useState([]);
  const [notify, setNotify] = useState(false);
  const [componentarr, setComponentarr] = useState([]);

  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [start, setStart] = useState(true);
  const [end, setEnd] = useState(true);
  const [notification, setNotification] = useState(true);
  const [startNotification, setstartNotification] = useState(true);
  const [endNotification, setendNotification] = useState(true);
  const [maintenance, setMaintenance] = useState(true);
  const [operational, setOpertional] = useState(true);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [placeholder, setPlaceholder] = useState(
    "We will be undergoing scheduled maintenance during this time."
  );

  const { toast } = usePopup();

  const { mutate: createMaintenanceMutate } = useMutation({
    mutationFn: createMaintenance,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Maintenance!";
      toast(message, "error");
    },
  });

  const {
    mutate: get_Components,
    data: records,
    isLoading: isCreate,
  } = useMutation({
    mutationFn: getComponents,
    onSuccess: (res) => {
      setComponents(res.data.components);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  useEffect(() => {
    get_Components();
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    let updatedMessage = message || placeholder;
    setMessage(updatedMessage);
    if (!date || !time) {
      console.error("Date or Time is missing");
      return;
    }
    const startDateTime = new Date(`${date}T${time}`);
    const endDateTime = new Date(`${date}T${time}`);
    if (hour || minute) {
      endDateTime.setHours(endDateTime.getHours() + parseInt(hour || 0));
      endDateTime.setMinutes(endDateTime.getMinutes() + parseInt(minute || 0));
    }
    createMaintenanceMutate({
      name: name,
      scheduledStart: startDateTime,
      scheduledEnd: endDateTime,
      autoUpdateMaintenanceAtStartTime: start,
      autoUpdateComponentsAtStartTime: maintenance,
      autoUpdateMaintenanceAtEndTime: end,
      autoUpdateComponentsAtEndTime: operational,
      affectedComponents: componentarr,
      sendNotifications: notification,
      message: updatedMessage,
    });
  };

  const onChangeHandler = (e) => {
    setStart(e.target.checked);
    setMaintenance(e.target.checked);
    setstartNotification(e.target.checked);
  };

  const onChangesHandler = (e) => {
    setEnd(e.target.checked);
    setOpertional(e.target.checked);
    setendNotification(e.target.checked);
  };

  return (
    <div class="text-gray-700 w-full max-w-[850px] mx-auto mt-6">
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Schedule Maintenance</div>
        <BackButton onClick={() => navigate("/view_incidents")}>
          Back to Maintenance
        </BackButton>
      </div>
      <form className="space-y-6" onSubmit={submitHandler}>
        <div className={`my-4 }`}>
          <div className="pb-1 text-gray-800">Maintenance name</div>
          <input
            type="text"
            onChange={(e) => setName(e.target.value)}
            className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full 
        }`}
            required
          />
          <div className={`my-4 `}>
            <div className="pb-1 text-gray-800">Date & Time</div>
            <input
              type="date"
              onChange={(e) => setDate(e.target.value)}
              min={moment().format("YYYY-MM-DD")}
              className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
              required
            />
            <input
              type="time"
              onChange={(e) => setTime(e.target.value)}
              className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
              required
            />
            <input
              id="hours"
              type="number"
              onChange={(e) => setHour(e.target.value)}
              placeholder="For Hours"
              className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
            />
            <input
              id="minutes"
              type="number"
              onChange={(e) => setMinute(e.target.value)}
              placeholder="For Minutes"
              className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
            />
          </div>

          <div className={`my-4 `}>
            <div className="pb-1 text-gray-800">Message</div>
            <textarea
              type="text"
              className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
              rows={4}
              cols={50}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={placeholder}
            />
          </div>
          <div className={`my-4 `}>
            <div className="pb-1 text-gray-800">Components affected</div>
            <hr />
            {components?.map((record, i) => {
              return (
                <AffectedItems
                  record={record}
                  options={componentstatus}
                  componentarr={componentarr}
                  setComponentarr={setComponentarr}
                />
              );
            })}
          </div>

          <div className={`my-4 }`}>
            <hr />
            <br />
            <div className="pb-1 text-gray-800">Notifications</div>
          </div>

          <div className={`my-1 ${notify && "is-disabled"}`}>
            <input
              type="checkbox"
              onChange={(e) => setNotification(e.target.checked)}
            />
            <span className="pb- text-gray-800 incident_checkbox">
              Send Notifications
            </span>
          </div>
        </div>
        <hr />
        <div className={`my-4 }`}>
          <label
            className="pb- text-gray-800 incident_checkbox"
            style={{ fontWeight: "bold" }}
          >
            Automation Options
          </label>
        </div>
        <div class="automation-options">
          <div class="automation-container">
            <div class="start-time-container">
              <div>
                <strong>At the start time</strong> for this maintenance
              </div>
              <br />
              <div className={`my-1`}>
                <input
                  type="checkbox"
                  onChange={onChangeHandler}
                  checked={start}
                />
                <span className="pb-1 text-gray-800 incident_checkbox">
                  Set status to 'In Progress'
                </span>
              </div>
              {start && (
                <div className="checkbox-list" style={{ paddingLeft: "24px" }}>
                  <div>
                    <input
                      type="checkbox"
                      checked={maintenance}
                      onChange={(e) => setMaintenance(e.target.checked)}
                    />
                    <span className="pb-1 text-gray-800 incident_checkbox">
                      Set affected components' status to 'Under Maintenance'
                    </span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={startNotification}
                      onChange={(e) => setstartNotification(e.target.checked)}
                    />
                    <span className="pb-1 text-gray-800 incident_checkbox">
                      Notify subscribers
                    </span>
                  </div>
                </div>
              )}
              <br />
            </div>
            <hr />
            <br />
            <div class="end-time-container">
              <div>
                <strong>At the end time</strong> for this maintenance
              </div>
              <br />
              <div className={`my-1`}>
                <input
                  type="checkbox"
                  onChange={onChangesHandler}
                  checked={end}
                />
                <span className="pb-1 text-gray-800 incident_checkbox">
                  Set status to 'Completed'
                </span>
              </div>
              {end && (
                <div className="checkbox-list" style={{ paddingLeft: "24px" }}>
                  <div>
                    <input
                      type="checkbox"
                      checked={operational}
                      onChange={(e) => setOpertional(e.target.checked)}
                    />
                    <span className="pb-1 text-gray-800 incident_checkbox">
                      Set affected components' status to 'Operational'
                    </span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      onChange={(e) => setendNotification(e.target.checked)}
                      checked={endNotification}
                    />
                    <span className="pb-1 text-gray-800 incident_checkbox">
                      Notify subscribers
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={`my-16 !w-fit `} style={{ float: "right" }}>
          <button
            type="submit"
            className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300
          }`}
          >
            Schedule now
            <div className="flex justify-center items-center"></div>
          </button>
          <br />
          <br />
        </div>
      </form>
    </div>
  );
}

export default MaintainanceForm;

const AffectedItems = ({ record, componentarr }) => {
  const [componentstatus, setComponentstatus] = useState(false);
  const [statusval, setStatusval] = useState("");

  function onChangeHandler(e) {
    setComponentstatus(e.target.checked);
    if (e.target.checked) {
      componentarr.push({ componentId: e.target.id });
    } else {
      const index = componentarr.findIndex(
        (item) => item.component === e.target.id
      );
      if (index !== -1) {
        componentarr.splice(index, 1);
      }
    }
  }

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="my-4" key={record._id}>
        <input
          name="affectedcomponents"
          checked={componentstatus}
          type="checkbox"
          id={record._id}
          onChange={onChangeHandler}
          value={statusval}
        />
        <span className="pb-1 text-gray-800 incident_checkbox">
          {record.name}
        </span>
      </div>
    </div>
  );
};
